let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});
async function getCsrfToken(): Promise<string> {
  const response = await fetch(`${BASE_URL}/csrf/token`, { method: "GET", credentials: "include" });
  const data = await response.json();
  return data.csrfToken;
}
function getToken() {
    return localStorage.getItem("d_c_c_t");
}


  export const getInformationUserRegister = async (
  formData: any
) => {
  try {
    const response = await fetch(
      "https://n8nio.pianat.ai/webhook/d6cb60ba-7b15-4a7f-b7a2-34fb27e4519d",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_data: formData }), // Changed to send as user_data object
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || "Failed to fetch company information");
    }

    const result = await response.json();
    if (!result[0]) {
      throw new Error("Invalid response structure");
    }

    return {
      success: true,
      companyData: result[0],
    };
  } catch (error: any) {
    return {
      success: false,
      message: error instanceof Error 
        ? error.message 
        : "Unexpected error during company info fetch",
    };
  }
};


// src/types/objectiveTypes.ts
export interface ApiObjective {
  objective_id: string;
  objective_name: string;
  description: string;
  estimated_effort: string;
  priority_rank: number;
  regulatory_reference: string;
  suggested_start_date: string;
  suggested_completion_date: string;
}

export interface CompanyData {
  organization_name: string;
  headquarters_country: string;
  industry_sectors: string[];
  entity_type: string;
  key_services: string[];
  company_size: {
    employees: number | null;
    revenue_band: string;
  };
  applicable_compliance_frameworks?: Array<{
    id: string;
    name: string;
    description?: string;
  }>;
}

export interface ApiResponse {
  success: boolean;
  data?: {
    roadmap?: ApiObjective[];
    data_sources?: string[];
    notes?: string;
  };
  message?: string;
}
export const getObjectiveInfoRegister = async (formData: any): Promise<ApiResponse> => {
  try {
    const response = await fetch(
      "https://n8nio.pianat.ai/webhook/2d55a552-14f1-4058-930d-3e7d08e840f8",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: formData }),
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || "Failed to fetch objectives");
    }

    const result = await response.json();

    // Handle the response structure you shared
    if (Array.isArray(result) && result.length > 0 && result[0].roadmap) {
      return {
        success: true,
        data: {
          roadmap: result[0].roadmap,
          data_sources: result[0].data_sources || [],
          notes: result[0].notes || ""
        }
      };
    }

    throw new Error("Invalid response structure");
  } catch (error: any) {
    return {
      success: false,
      message: error instanceof Error 
        ? error.message 
        : "Unexpected error during objectives fetch",
    };
  }
};

// Requires CSRF token
export async function submitObjectiveInfo(token: string, data: any[]): Promise<any> {
  const csrfToken = await getCsrfToken();

  const response = await fetch(`${BASE_URL}/registration-steps/objective-info?token=${token}`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify({ data }),
  });

  const result = await response.json();

  if (result.isSuccess && result.data?.token) {
    localStorage.setItem("token", result.data.token);
  }

  return result;
}

  export async function getInformationUser() {
      try {      
          const token = getToken();
       
       
      const headers = {
          "Content-Type": "application/json",
         ...(token ? { Authorization: `Bearer ${token}` } : {}),
          "X-CSRF-TOKEN": await getCsrfToken(),
         
      };
          const response = await fetch(`${BASE_URL}/information/user`, {
              method: "GET", 
              credentials: "include",
              headers,
          });
    
          const data = await response.json();
          if (!response || !data) {
              if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                  throw new Error("Forbidden: You do not have permission to access this resource.");
              }
              throw new Error("Failed to fetch");
          }
          return data;
      } catch (error: any) {
          throw new Error(error);
      }
    }



    export async function submitComplianceByFramwork(data: any) {
      const token = getToken();
      try {
        const response = await fetch(`${BASE_URL}/compliance/bulk`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'X-CSRF-Token': await getCsrfToken(),
          },
          body: JSON.stringify(data),
        });
    
        if (!response.ok) {
          throw new Error(`Failed to submit answers. Status: ${response.status}`);
        }
    
        const result = await response.json();
        return result;
      } catch (error) {
        console.error('Error submitting answers:', error);
        throw error;
      }
    }
    



    export async function getMappedObjectives(data: any) {
  try {
    const response = await fetch(
      "https://n8nio.pianat.ai/webhook/60f7bc39-248f-4b01-a3ab-bb28d2e1308f",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data }),
      }
    );

    if (!response.ok) {
      throw new Error(`Mapper Agent failed with status: ${response.status}`);
    }

    const result = await response.json();
    return result; // Expecting output[], data_sources[]
  } catch (error) {
    console.error("Error calling Mapper Agent:", error);
    throw error;
  }
}



export async function mapControls(data: any) {
    try {
        const response = await fetch(`${BASE_URL}/controls/mapper`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getToken()}`,
                "X-CSRF-TOKEN": await getCsrfToken(),
            },
            body: JSON.stringify({
                applicable_frameworks: data.applicable_frameworks,
               
            }),
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error mapping controls:', error);
        throw new Error('Error mapping controls');
    }
}


